import { Tooltip, Typography } from '@mui/material';
import React, { useRef, useState, useEffect } from 'react';

export const OverflowTooltip = ({
  text = '',
  renderContent,
  shouldCloseOnScroll,
}: {
  text: string | undefined;
  renderContent?: (
    text: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: React.RefObject<any>
  ) => React.ReactElement;
  shouldCloseOnScroll?: boolean;
}) => {
  const textElementRef = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (textElementRef.current) {
      setIsOverflow(
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth
      );
    }
  }, [text]);

  useEffect(() => {
    if (!shouldCloseOnScroll) return;

    const handleScroll = () => {
      setIsOpen(false);
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [shouldCloseOnScroll]);

  return (
    <Tooltip
      title={isOverflowed ? text : undefined}
      open={shouldCloseOnScroll ? isOpen : undefined}
      onOpen={() => shouldCloseOnScroll && setIsOpen(true)}
      onClose={() => shouldCloseOnScroll && setIsOpen(false)}
    >
      {renderContent ? (
        renderContent(text, textElementRef)
      ) : (
        <Typography
          component={'span'}
          ref={textElementRef}
          className='truncate'
        >
          {text}
        </Typography>
      )}
    </Tooltip>
  );
};
